import { useRouteMatch } from 'react-router';
import { usePrevious, useUpdateEffect } from 'react-use';

import { visitPaths } from '~libs.desktop.shared.paths';

type UseConsentTemplateRouteMatchOptions = {
   onLeave: VoidFunction;
};

export const useConsentTemplateRouteMatch = (options: UseConsentTemplateRouteMatchOptions): void => {
   const documentTemplateRouteMatch = useRouteMatch({
      path: [visitPaths.CONSENT_TEMPLATE_PATH],
   });

   const previousConsentTemplateRouteMatch = usePrevious(documentTemplateRouteMatch);

   useUpdateEffect(() => {
      if (previousConsentTemplateRouteMatch?.url !== documentTemplateRouteMatch?.url) {
         options.onLeave();
      }
   }, [documentTemplateRouteMatch]);
};
